import * as React from 'react';
export var useChartUpdates = function useChartUpdates(chart, chartConfig) {
  React.useEffect(function () {
    if (chart && chartConfig) {
      for (var i = 0; i < chartConfig.data.datasets.length; i++) {
        chart.data.datasets[i].data = chartConfig.data.datasets[i].data;
        chart.data.datasets[i].label = chartConfig.data.datasets[i].label;
      }
      chart.data.labels = chartConfig.data.labels;
      chart.options = Object.assign({}, chartConfig.options);
      chart.update();
    }
  }, [chartConfig, chart]);
};